import * as rootSaga from './modules/sagas';

export default function initSaga(sagaMiddleware) {
  Object.values(rootSaga).forEach(sagaMiddleware.run.bind(sagaMiddleware));
}
